import React, { useState } from 'react';
import './MedVed.css';

const MedVed = () => {
    // Mock FAQ Data (Replace with actual FAQs later)
    const faqs = [
        { question: "What services do you offer?", answer: "We provide a wide range of services including custom consulting, support, and product solutions tailored to your business needs." },
        { question: "How can I contact support?", answer: "You can contact our support team via email at support@toptierbenefits.com" },
        { question: "What are your operating hours?", answer: "Our business operates Monday to Friday, from 8 AM to 6 PM CST." },
    ];

    // Expand/collapse FAQ answers
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="medved-container">
            <h1 className="medved-title">MedVed</h1>

            {/* Link Box */}
            <a href="https://ca.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=f1df01a9-ca9f-4a96-be75-7265366d3ce7&env=ca&acct=e6b74557-3473-4b9f-856e-4ebef6b2b3c7&v=2" target="_blank" rel="noopener noreferrer" className="medved-box">
                <div className="medved-content">
                    <h2>PATIENT ENROLLMENT FORM</h2>
                </div>
            </a>

            {/* FAQ Section */}
            <div className="medved-faq-section">
                <h2 className="medved-faq-title">Frequently Asked Questions</h2>
                <div className="medved-faq-list">
                    {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className={`medved-faq-item ${openIndex === index ? "active" : ""}`}
                        onClick={() => toggleFAQ(index)}
                    >
                        <div className="medved-faq-question">
                        <strong>{faq.question}</strong>
                        <span className="medved-faq-icon">{openIndex === index ? "-" : "+"}</span>
                        </div>
                        <div className={`medved-faq-answer ${openIndex === index ? "show" : ""}`}>
                        {faq.answer}
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MedVed;